import React, { useEffect } from "react";
import { ConnectedProps } from "react-redux";
import { Table, Tag } from "antd";
import dayjs from "dayjs";

import connector from "./Container";
import { type ErrorLogResponse } from "../../models";

const PAGE_SIZE = 25;

const statusColor = (status: number) => (status >= 500 ? "red" : "orange");

const columns = [
  {
    title: "Vrijeme",
    dataIndex: "createdAt",
    key: "createdAt",
    width: 180,
    render: (value: string) => dayjs(value).format("DD.MM.YYYY HH:mm:ss"),
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    width: 100,
    render: (value: number) => <Tag color={statusColor(value)}>{value}</Tag>,
  },
  {
    title: "Metoda",
    dataIndex: "method",
    key: "method",
    width: 100,
  },
  {
    title: "URL",
    dataIndex: "url",
    key: "url",
  },
  {
    title: "Poruka",
    dataIndex: "message",
    key: "message",
  },
];

const ErrorLogs = ({ state, actions }: ConnectedProps<typeof connector>) => {
  const { errorLogs, total, page, loading } = state;
  const { getErrorLogs } = actions;

  useEffect(() => {
    getErrorLogs(1, PAGE_SIZE);
  }, []);

  return (
    <div className="p-4">
      <h2 className="text-xl font-semibold mb-4">Greške</h2>
      <Table
        columns={columns}
        dataSource={errorLogs}
        rowKey={(record: ErrorLogResponse) => record.id}
        loading={loading}
        pagination={{
          current: page,
          pageSize: PAGE_SIZE,
          total,
          onChange: (newPage) => getErrorLogs(newPage, PAGE_SIZE),
        }}
      />
    </div>
  );
};

export default ErrorLogs;
